import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/authContext';
import { adminService } from '../../services/adminService';
import '../../styles/admin.css'; // Import admin-specific styles

const AdminDashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState({
    totalProducts: 0,
    totalOrders: 0,
    totalCustomers: 0,
    revenue: 0,
    totalBlogPosts: 0
  });

  useEffect(() => {
    loadDashboardStats();
  }, []);

  const loadDashboardStats = async () => {
    try {
      const [orders, blogPosts] = await Promise.all([
        adminService.getOrders(),
        adminService.getBlogPosts()
      ]);
      const revenue = orders.reduce((sum, order) => sum + (order.totalPrice || 0), 0);
      setStats({
        totalProducts: 45,
        totalOrders: orders.length,
        totalCustomers: 89,
        revenue,
        totalBlogPosts: blogPosts.length
      });
    } catch (error) {
      console.error('Error loading dashboard stats:', error);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'MAD'
    }).format(amount);
  };

  return (
    <div className="admin-dashboard" style={{ background: "#f4f6fb", minHeight: "100vh", paddingBottom: 40 }}>
      <div className="container" style={{ maxWidth: 1150, margin: "0 auto", padding: "0 12px" }}>
        <div className="dashboard-header" style={{
          display: "flex", alignItems: "center", justifyContent: "space-between", padding: "38px 0 30px 0"
        }}>
          <div className="welcome-section">
            <h1 style={{ fontWeight: 800, fontSize: 32, color: "#222", marginBottom: 8 }}>
              <i className="fas fa-tachometer-alt" style={{ color: "#8374e6", marginRight: 9 }}></i>
              Admin Dashboard
            </h1>
            <p style={{ color: "#7a8299", fontSize: 17, fontWeight: 500 }}>
              Welcome back, <span style={{ color: "#e74c3c" }}>{user?.name || 'Admin'}</span>! Here's what's happening with your store today.
            </p>
          </div>
          <div className="quick-actions">
            <Link to="/admin/products/add"
              className="btn btn-primary"
              style={{
                background: "#8374e6", color: "#fff", fontWeight: 700, fontSize: 17,
                borderRadius: 9, padding: "11px 30px", border: "none", boxShadow: "0 2px 8px #e3e3ff"
              }}>
              <i className="fas fa-plus"></i> Add Product
            </Link>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="stats-grid" style={{
          display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "26px", marginBottom: 45
        }}>
          <div className="stat-card" style={{
            background: "#fff", borderRadius: 17, padding: "38px 22px 26px 28px",
            display: "flex", alignItems: "flex-start", gap: 19, boxShadow: "0 2px 18px #f4eaea"
          }}>
            <div className="stat-icon products" style={{
              color: "#8374e6", fontSize: 34, background: "#f3f1fe", borderRadius: 10, padding: 11, minWidth: 44, textAlign: "center"
            }}>
              <i className="fas fa-box"></i>
            </div>
            <div className="stat-content">
              <h3 style={{ margin: 0, fontSize: 28, fontWeight: 700 }}>{stats.totalProducts}</h3>
              <p style={{ margin: 0, color: "#7a8299", fontWeight: 500 }}>Total Products</p>
            </div>
          </div>

          <div className="stat-card" style={{
            background: "#fff", borderRadius: 17, padding: "38px 22px 26px 28px",
            display: "flex", alignItems: "flex-start", gap: 19, boxShadow: "0 2px 18px #f4eaea"
          }}>
            <div className="stat-icon orders" style={{
              color: "#e74c3c", fontSize: 34, background: "#fff2ef", borderRadius: 10, padding: 11, minWidth: 44, textAlign: "center"
            }}>
              <i className="fas fa-shopping-cart"></i>
            </div>
            <div className="stat-content">
              <h3 style={{ margin: 0, fontSize: 28, fontWeight: 700 }}>{stats.totalOrders}</h3>
              <p style={{ margin: 0, color: "#7a8299", fontWeight: 500 }}>Total Orders</p>
            </div>
          </div>

          <div className="stat-card" style={{
            background: "#fff", borderRadius: 17, padding: "38px 22px 26px 28px",
            display: "flex", alignItems: "flex-start", gap: 19, boxShadow: "0 2px 18px #f4eaea"
          }}>
            <div className="stat-icon customers" style={{
              color: "#5dc25a", fontSize: 34, background: "#ecfcef", borderRadius: 10, padding: 11, minWidth: 44, textAlign: "center"
            }}>
              <i className="fas fa-users"></i>
            </div>
            <div className="stat-content">
              <h3 style={{ margin: 0, fontSize: 28, fontWeight: 700 }}>{stats.totalCustomers}</h3>
              <p style={{ margin: 0, color: "#7a8299", fontWeight: 500 }}>Customers</p>
            </div>
          </div>

          <div className="stat-card" style={{
            background: "#fff", borderRadius: 17, padding: "38px 22px 26px 28px",
            display: "flex", alignItems: "flex-start", gap: 19, boxShadow: "0 2px 18px #f4eaea"
          }}>
            <div className="stat-icon revenue" style={{
              color: "#f9ca24", fontSize: 34, background: "#fffbe9", borderRadius: 10, padding: 11, minWidth: 44, textAlign: "center"
            }}>
              <i className="fas fa-dollar-sign"></i>
            </div>
            <div className="stat-content">
              <h3 style={{ margin: 0, fontSize: 28, fontWeight: 700 }}>{formatCurrency(stats.revenue)}</h3>
              <p style={{ margin: 0, color: "#7a8299", fontWeight: 500 }}>Total Revenue</p>
            </div>
          </div>

          <div className="stat-card" style={{
            background: "#fff", borderRadius: 17, padding: "38px 22px 26px 28px",
            display: "flex", alignItems: "flex-start", gap: 19, boxShadow: "0 2px 18px #f4eaea"
          }}>
            <div className="stat-icon blog" style={{
              color: "#012E16", fontSize: 34, background: "#e6f4ec", borderRadius: 10, padding: 11, minWidth: 44, textAlign: "center"
            }}>
              <i className="fas fa-newspaper"></i>
            </div>
            <div className="stat-content">
              <h3 style={{ margin: 0, fontSize: 28, fontWeight: 700 }}>{stats.totalBlogPosts}</h3>
              <p style={{ margin: 0, color: "#7a8299", fontWeight: 500 }}>Articles de blog</p>
            </div>
          </div>
        </div>

        {/* Quick Actions Section */}
        <div className="dashboard-sections">
          <div className="section" style={{ background: "#fff", borderRadius: 15, padding: "28px 28px 20px 28px", boxShadow: "0 2px 18px #f7f7ff" }}>
            <h2 style={{ color: "#8374e6", fontWeight: 700, fontSize: 22, marginBottom: 19 }}>
              <i className="fas fa-cogs"></i> Quick Actions
            </h2>
            <div className="action-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
                gap: 22
              }}>
              <Link to="/admin/products" className="action-card"
                style={{
                  background: "#f3f1fe", borderRadius: 12, padding: "22px 20px", display: "flex", alignItems: "center", gap: 17,
                  transition: "box-shadow .12s, transform .12s", boxShadow: "0 1px 8px #ece5ff", textDecoration: "none"
                }}>
                <div className="action-icon" style={{ color: "#8374e6", fontSize: 26, background: "#fff", borderRadius: 8, padding: 10, minWidth: 38, textAlign: "center" }}>
                  <i className="fas fa-box"></i>
                </div>
                <div className="action-content" style={{ flex: 1 }}>
                  <h3 style={{ fontWeight: 700, fontSize: 18, margin: 0, color: "#222" }}>Manage Products</h3>
                  <p style={{ color: "#7a8299", fontSize: 15, margin: 0 }}>Add, edit, or remove products from your inventory</p>
                </div>
                <div className="action-arrow" style={{ color: "#8374e6", fontSize: 20 }}>
                  <i className="fas fa-chevron-right"></i>
                </div>
              </Link>

              <Link to="/admin/promotions" className="action-card promotion-action"
                style={{
                  background: "#fff2ef", borderRadius: 12, padding: "22px 20px", display: "flex", alignItems: "center", gap: 17,
                  transition: "box-shadow .12s, transform .12s", boxShadow: "0 1px 8px #ffe8e2", textDecoration: "none"
                }}>
                <div className="action-icon" style={{ color: "#e74c3c", fontSize: 26, background: "#fff", borderRadius: 8, padding: 10, minWidth: 38, textAlign: "center" }}>
                  <i className="fas fa-tags"></i>
                </div>
                <div className="action-content" style={{ flex: 1 }}>
                  <h3 style={{ fontWeight: 700, fontSize: 18, margin: 0, color: "#222" }}>Manage Promotions</h3>
                  <p style={{ color: "#7a8299", fontSize: 15, margin: 0 }}>Add, edit, or remove promotional products</p>
                </div>
                <div className="action-arrow" style={{ color: "#e74c3c", fontSize: 20 }}>
                  <i className="fas fa-chevron-right"></i>
                </div>
              </Link>

              <Link to="/admin/orders" className="action-card"
                style={{
                  background: "#ecfcef", borderRadius: 12, padding: "22px 20px", display: "flex", alignItems: "center", gap: 17,
                  transition: "box-shadow .12s, transform .12s", boxShadow: "0 1px 8px #e5fbe7", textDecoration: "none"
                }}>
                <div className="action-icon" style={{ color: "#5dc25a", fontSize: 26, background: "#fff", borderRadius: 8, padding: 10, minWidth: 38, textAlign: "center" }}>
                  <i className="fas fa-list-alt"></i>
                </div>
                <div className="action-content" style={{ flex: 1 }}>
                  <h3 style={{ fontWeight: 700, fontSize: 18, margin: 0, color: "#222" }}>View Orders</h3>
                  <p style={{ color: "#7a8299", fontSize: 15, margin: 0 }}>Track and manage customer orders</p>
                </div>
                <div className="action-arrow" style={{ color: "#5dc25a", fontSize: 20 }}>
                  <i className="fas fa-chevron-right"></i>
                </div>
              </Link>

              <Link to="/admin/blog" className="action-card"
                style={{
                  background: "#e6f4ec", borderRadius: 12, padding: "22px 20px", display: "flex", alignItems: "center", gap: 17,
                  transition: "box-shadow .12s, transform .12s", boxShadow: "0 1px 8px #d9f0e3", textDecoration: "none"
                }}>
                <div className="action-icon" style={{ color: "#012E16", fontSize: 26, background: "#fff", borderRadius: 8, padding: 10, minWidth: 38, textAlign: "center" }}>
                  <i className="fas fa-newspaper"></i>
                </div>
                <div className="action-content" style={{ flex: 1 }}>
                  <h3 style={{ fontWeight: 700, fontSize: 18, margin: 0, color: "#222" }}>Manage Blog</h3>
                  <p style={{ color: "#7a8299", fontSize: 15, margin: 0 }}>Write, edit, and publish blog articles</p>
                </div>
                <div className="action-arrow" style={{ color: "#012E16", fontSize: 20 }}>
                  <i className="fas fa-chevron-right"></i>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;